import LocalStorageNamespace from "./createNamespaces";

export default LocalStorageNamespace;

export { default as createLocalStorageContextProvider } from "./createContextProvider";
